import { gql } from '@apollo/client';
import { ASSESSMENT_REPORT_BASE } from 'graph/fragments/assessment-report';

const GET_ASSESSMENT_REPORT = gql`
  ${ASSESSMENT_REPORT_BASE}

  query AssessmentReport($where: AssessmentReportWhereInput!) {
    assessmentReport(where: $where) {
      ...AssessmentReportBase
    }
  }
`;

export default GET_ASSESSMENT_REPORT;
